import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Grid,
  Button,
  Box,
  Chip,
  CircularProgress,
  Divider,
  Paper,
  LinearProgress,
} from "@mui/material";
import {} from "@mui/icons-material";
import { useAuth, api } from "../context/AuthContext";
import axios from "axios";

function Subscription() {
  const { user, setUser } = useAuth();
  const [payments, setPayments] = useState([]);
  const [jobCredits, setJobCredits] = useState([]);
  const [applications, setApplications] = useState([]);
  const [starterUsage, setStarterUsage] = useState(null);
  const [professionalUsage, setProfessionalUsage] = useState(null);
  const [overageUsage, setOverageUsage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    async function fetchSubscriptionData() {
      try {

        const userResponse =
          await api.get("/auth/user");

        setUser(userResponse.data);

        const response =
          await axios.get(
            "https://api.exihire.com/api/payment/history"
          );

        const creditsResponse =
          await axios.get(
            "https://api.exihire.com/api/job-credits/my-credits"
          );

        const applicationsResponse =
          await api.get("/applications?page=1&limit=10000");

        const starterUsageResponse =
          await api.get("/applications/starter-usage");

        const professionalUsageResponse =
          await api.get("/applications/professional-usage");

        const overageUsageResponse =
          await api.get("/applications/overage-usage");

        console.log(
          "APPLICATION API RESPONSE:",
          applicationsResponse.data
        );

        console.log(
          "STARTER USAGE API:",
          starterUsageResponse.data
        );

        console.log(
          "PROFESSIONAL USAGE API:",
          professionalUsageResponse.data
        );

        console.log(
          "OVERAGE USAGE API:",
          overageUsageResponse.data
        );

        // Always set usage states regardless of payment history API response shape
        setStarterUsage(starterUsageResponse.data);
        setProfessionalUsage(professionalUsageResponse.data);
        setOverageUsage(overageUsageResponse.data);

        if (Array.isArray(response.data)) {

          setPayments(response.data);

          if (
            Array.isArray(creditsResponse.data)
          ) {

            setJobCredits(
              creditsResponse.data
            );

          } else {

            setJobCredits([]);

          }

          // ✅ ALWAYS refresh applications separately

          if (
            Array.isArray(
              applicationsResponse.data
                ?.applications
            )
          ) {

            setApplications(
              applicationsResponse.data
                .applications
            );

            console.log(
              "APPLICATIONS:",
              applicationsResponse.data
                .applications
            );

          } else if (
            Array.isArray(
              applicationsResponse.data
            )
          ) {

            setApplications(
              applicationsResponse.data
            );

            console.log(
              "APPLICATIONS:",
              applicationsResponse.data
            );

          } else {

            setApplications([]);

          }


        } else {

          setPayments([]);

        }

      } catch (error) {

        console.error(
          "Failed to fetch subscription data:",
          error
        );

        setPayments([]);

      } finally {

        setLoading(false);

      }
    }

    fetchSubscriptionData();

    const interval =
      setInterval(() => {

        fetchSubscriptionData();

      }, 5000);

    return () => clearInterval(interval);

  }, []);

  const now = new Date();

 const activeCredits = Array.isArray(jobCredits)
   ? jobCredits.filter(
       (credit) =>
         credit &&
         !credit.used_at &&
         credit.expires_at &&
         new Date(credit.expires_at) > now
     )
   : [];

   const latestCredit =
     Array.isArray(jobCredits) &&
     jobCredits.length > 0
       ? [...jobCredits].sort(
           (a, b) =>
             new Date(b.created_at) -
             new Date(a.created_at)
         )[0]
       : null;

   const validCreditsCount =
     activeCredits.length;

    const PLAN_LIMITS = {
      FREE_TRIAL: {
        jobs: 2,
        applications: 5,
        validityDays: 15,
        color: "#6f2dbd",
      },

      PAY_AS_YOU_GO: {
        jobs: validCreditsCount,

        applications: validCreditsCount * 5,


        validityDays: 30,
        color: "#1565c0",
      },

      STARTER: {
        jobs: 10,
        applications: 50,
        validityDays: 30,
        color: "#4F46E5",
      },

      PROFESSIONAL: {
        jobs: 50,
        applications: 300,
        validityDays: 365,
        color: "#ef6c00",
      },
    };

    let detectedPlan = null;

    // ✅ PRIORITY 1 → PROFESSIONAL

    if (
      user?.plan &&
      (
        user.plan.toLowerCase() === "professional" ||
        user.plan.toLowerCase() === "annual"
      )
    ) {
      detectedPlan = "PROFESSIONAL";
    }

    // ✅ PRIORITY 2 → STARTER

    else if (
      user?.plan &&
      user.plan.toLowerCase() === "monthly"
    ) {
      detectedPlan = "STARTER";
    }

    // ✅ PRIORITY 3 → PAYG

    else if (
      user?.plan &&
      user.plan.toLowerCase() === "pay_as_you_go"
    ) {
      detectedPlan = "PAY_AS_YOU_GO";
    }

    // ✅ FALLBACK FROM PAYMENTS

    else if (
      payments.some(
        (p) =>
          p.plan_code
            ?.toUpperCase()
            .includes("PROFESSIONAL") &&
          p.expires_at &&
          new Date(p.expires_at) > now
      )
    ) {
      detectedPlan = "PROFESSIONAL";
    }

    else if (
      payments.some(
        (p) =>
          p.plan_code
            ?.toUpperCase()
            .includes("STARTER") &&
          p.expires_at &&
          new Date(p.expires_at) > now
      )
    ) {
      detectedPlan = "STARTER";
    }

    else if (
      jobCredits.some(
        (credit) =>
          !credit.used_at &&
          (
            !credit.expires_at ||
            new Date(credit.expires_at) > now
          )
      )
    ) {
      detectedPlan = "PAY_AS_YOU_GO";
    }

    let currentPlan = detectedPlan;

    if (detectedPlan) {
      currentPlan = detectedPlan;
    }

    console.log("PAYMENTS:", payments);

    console.log("DETECTED PLAN:", detectedPlan);
    console.log("CURRENT PLAN:", currentPlan);

    const hasActivePaidPlan =
      currentPlan === "PAY_AS_YOU_GO" ||
      currentPlan === "STARTER" ||
      currentPlan === "PROFESSIONAL";

    if (!hasActivePaidPlan && user?.plan === 'free_trial') {
      currentPlan = "FREE_TRIAL";
    }

    const limits = PLAN_LIMITS[currentPlan];

    const jobsLimit = limits?.jobs || 0;

    const applicationsLimit =
      limits?.applications || 0;

    // PAYG TOTAL PURCHASED
    const totalPurchasedJobs =
      currentPlan === "PAY_AS_YOU_GO"
        ? jobCredits.filter(
            (credit) =>
              !credit.expires_at ||
              new Date(credit.expires_at) > now
          ).length
        : jobsLimit;

    // USED JOBS
    const usedJobs =
      currentPlan === "PAY_AS_YOU_GO"
        ? jobCredits.filter(
            (credit) =>
              credit.used_at &&
              (
                !credit.expires_at ||
                new Date(credit.expires_at) > now
              )
          ).length
        : 0;

    // REMAINING JOBS
    const remainingJobs =
      currentPlan === "FREE_TRIAL"
        ? Number(user?.job_limit ?? jobsLimit)

        : currentPlan === "PAY_AS_YOU_GO"
        ? totalPurchasedJobs - usedJobs

        : currentPlan === "STARTER"
        ? Math.max(
            starterUsage?.remainingJobs ?? 10,
            0
          )

        : currentPlan === "PROFESSIONAL"
        ? Math.max(
            professionalUsage?.remainingJobs ?? 50,
            0
          )

        : Number(user?.job_limit ?? jobsLimit ?? 0);

    // TOTAL APPLICATIONS
    const totalApplicationsLimit =
      currentPlan === "PAY_AS_YOU_GO"
        ? totalPurchasedJobs * 5
        : applicationsLimit;

    console.log(
      "LIVE APPLICATIONS:",
      applications
    );

    // FIRST PAYG PURCHASE DATE
    const firstPaygPurchaseDate =
      jobCredits.length > 0
        ? new Date(
            [...jobCredits].sort(
              (a, b) =>
                new Date(a.created_at) -
                new Date(b.created_at)
            )[0].created_at
          )
        : null;

    // USED APPLICATIONS
    const processedApplications =
      currentPlan === "PAY_AS_YOU_GO"
        ? applications.reduce((count, app) => {

            const applicationDate =
              new Date(app.created_at);

            // ✅ once shortlisted, always counted
            const wasProcessed =
              app.status_history?.includes(
                "application_shortlisted"
              ) ||
              app.status ===
                "application_shortlisted" ||
              app.status ===
                "ai_coding_scheduled" ||
              app.status ===
                "ai_coding_completed" ||
              app.status ===
                "technical_scheduled" ||
              app.status ===
                "technical_completed" ||
              app.status ===
                "hr_scheduled" ||
              app.status ===
                "hr_completed" ||
              app.status ===
                "candidate_selected" ||
              app.status ===
                "candidate_rejected" ||
              app.status ===
                "offer_released";

            if (
              wasProcessed &&
              app.job_id &&
              firstPaygPurchaseDate &&
              applicationDate >= firstPaygPurchaseDate
            ) {
              return count + 1;
            }

            return count;

          }, 0)
        : 0;

    console.log(
      "PROCESSED APPLICATIONS:",
      processedApplications
    );

    // REMAINING APPLICATIONS


    const remainingApplications =
      currentPlan === "FREE_TRIAL"
        ? Number(
            user?.application_limit ??
            applicationsLimit
          )

        : currentPlan === "PAY_AS_YOU_GO"
        ? Math.max(
            totalApplicationsLimit -
              processedApplications,
            0
          )

        : currentPlan === "STARTER"
        ? Math.max(
            starterUsage?.remaining ?? 50,
            0
          )

        : currentPlan === "PROFESSIONAL"
        ? Math.max(
            professionalUsage?.remaining ?? 300,
            0
          )

        : Number(
            user?.application_limit ??
            applicationsLimit ??
            0
          );

    console.log(
      "REMAINING APPLICATIONS:",
      remainingApplications
    );

    console.log(
      "STARTER USAGE OBJECT:",
      starterUsage
    );

    console.log(
      "STARTER USED:",
      starterUsage?.used
    );

    console.log(
      "STARTER REMAINING:",
      starterUsage?.remaining
    );

    console.log(
      "STARTER LIMIT:",
      starterUsage?.limit
    );

    console.log(
      "FINAL REMAINING JOBS:",
      remainingJobs
    );

    console.log(
      "FINAL REMAINING APPLICATIONS:",
      remainingApplications
    );

    const usageCompleted =
      remainingJobs <= 0 &&
      remainingApplications <= 0;




    let expiryDate = null;

    if (currentPlan === "FREE_TRIAL") {

      expiryDate =
        user?.free_trial_expires_at;

    }

    else if (
      currentPlan === "PAY_AS_YOU_GO"
    ) {

      expiryDate =
        latestCredit?.expires_at;

    }

    else if (
      currentPlan === "STARTER"
    ) {

      const starterPayment = Array.isArray(payments) ? payments.find(p => 
        p.plan_code?.toUpperCase().includes("STARTER") && 
        p.expires_at && 
        new Date(p.expires_at) > now
      ) : null;

      expiryDate =
        user?.subscription_expires_at ||
        user?.plan_expires_at ||
        user?.expires_at ||
        starterPayment?.expires_at;

    }

    else if (
      currentPlan === "PROFESSIONAL"
    ) {

      const professionalPayment = Array.isArray(payments) ? payments.find(p => 
        p.plan_code?.toUpperCase().includes("PROFESSIONAL") && 
        p.expires_at && 
        new Date(p.expires_at) > now
      ) : null;

      expiryDate =
        user?.subscription_expires_at ||
        user?.plan_expires_at ||
        user?.expires_at ||
        professionalPayment?.expires_at;

    }

    let remainingDays = 0;

    if (expiryDate) {
      remainingDays = Math.max(
        0,
        Math.ceil(
          (new Date(expiryDate) - now) /
            (1000 * 60 * 60 * 24)
        )
      );
    }

    const isPlanExpired =
      usageCompleted ||
      (
        expiryDate &&
        new Date(expiryDate) < now
      );




  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4"
                  sx={{
                      color: "#4F46E5", // Accent Text
                      fontWeight: "bold",
                      mb: 3
                  }}
      >
        My Subscription
      </Typography>

      <Paper
        elevation={3}
        sx={{
          mb: 6,
          p: 4,
          borderRadius: 3,
          background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
          border: "1px solid #e0e0e0",
        }}
      >




        {currentPlan === "FREE_TRIAL" ? (
          <>
            {/* FREE TRIAL UI */}

            <Grid container spacing={3}>
              {/* LEFT MAIN CARD */}

              <Grid item xs={12}>
                <Paper
                  elevation={0}
                  sx={{
                    border: "1px solid #ececec",
                    borderRadius: 3,
                    p: 3,
                  }}
                >
                  <Grid container spacing={3}>
                    {/* LEFT SIDE */}

                    <Grid item xs={12} md={5}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          textTransform: "uppercase",
                          fontWeight: "bold",
                          color: "#666",
                          mb: 1,
                        }}
                      >
                        CURRENT PLAN STATUS
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 2,
                        }}
                      >
                        <Typography
                          variant="h4"
                          sx={{
                            fontWeight: "bold",
                            color: "#6f2dbd",
                          }}
                        >
                          Free Trial
                        </Typography>

                        <Chip
                          label={
                            isPlanExpired
                              ? "EXPIRED"
                              : "ACTIVE"
                          }
                          sx={{
                            background: isPlanExpired
                              ? "#eeeeee"
                              : "#efe3ff",

                            color: isPlanExpired
                              ? "#666"
                              : "#6f2dbd",
                            fontWeight: "bold",
                          }}
                        />
                      </Box>

                      <Typography
                        variant="body2"
                        sx={{
                          mb: 3,
                          color: "#555",
                        }}
                      >
                        Enjoy full access to ExiHire during your free trial period.
                      </Typography>

                      <Typography sx={{ mb: 1 }}>
                        Valid Till: <strong>{new Date(expiryDate).toLocaleDateString("en-US", {
                                            month: "long",
                                            day: "numeric",
                                            year: "numeric",
                                          })}</strong>
                      </Typography>

                      <Typography sx={{ mb: 1 }}>
                        Trial Started On: <strong>{user?.free_trial_started_at
                                                    ? new Date(
                                                        user.free_trial_started_at
                                                      ).toLocaleDateString("en-US", {
                                                        month: "long",
                                                        day: "numeric",
                                                        year: "numeric",
                                                      })
                                                    : new Date(
                                                        user.created_at
                                                      ).toLocaleDateString("en-US", {
                                                        month: "long",
                                                        day: "numeric",
                                                        year: "numeric",
                                                      })}</strong>
                      </Typography>

                      <Typography sx={{ mb: 3 }}>
                        Trial Duration: <strong>15 Days</strong>
                      </Typography>

                      <Box sx={{ display: "flex", gap: 2 }}>
                        <Button
                          variant="contained"
                          sx={{
                            background: "#6f2dbd",
                          }}
                          onClick={() =>
                            (window.location.href = "/pricing")
                          }
                        >
                          Explore Plans
                        </Button>


                      </Box>
                    </Grid>

                    {/* LIMITS */}

                    <Grid item xs={12} md={4}>
                      <Paper
                        elevation={0}
                        sx={{
                          p: 3,
                          background: "#faf5ff",
                          borderRadius: 3,
                          height: "100%",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            color: "#6f2dbd",
                            mb: 3,
                          }}
                        >
                          Your Free Trial Limits
                        </Typography>

                        <Typography variant="body2">
                          Active Job Postings
                        </Typography>

                        <Divider sx={{ my: 1 }} />

                        <Typography
                          sx={{
                            color: "#6f2dbd",
                            fontWeight: "bold",
                            mb: 3,
                          }}
                        >
                          {remainingJobs} / {jobsLimit}
                        </Typography>

                        <Typography variant="body2">
                          Candidate Applications
                        </Typography>

                        <Divider sx={{ my: 1 }} />

                        <Typography
                          sx={{
                            color: "#6f2dbd",
                            fontWeight: "bold",
                          }}
                        >
                          {remainingApplications} / {applicationsLimit}
                        </Typography>

                        <Typography
                          variant="caption"
                          sx={{
                            display: "block",
                            mt: 1,
                            color: "#777",
                            lineHeight: 1.6,
                          }}
                        >
                          Free trial usage does not carry forward after upgrading.
                          Any unused job postings or application processing limits
                          from the free trial will expire once a paid plan or
                          Pay-As-You-Go credits are activated.
                        </Typography>

                      </Paper>
                    </Grid>

                    {/* ALERT */}

                    <Grid item xs={12} md={3}>
                      <Paper
                        elevation={0}
                        sx={{
                          p: 3,
                          background: "#faf5ff",
                          borderRadius: 3,
                          height: "100%",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            color: "#6f2dbd",
                            mb: 2,
                          }}
                        >
                          You are on Free Trial
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{
                            lineHeight: 2,
                            color: "#555",
                          }}
                        >
                          {isPlanExpired ? (
                            <>
                              Your free trial usage has been completed.
                              <br />
                              <br />
                              Upgrade to continue posting jobs and processing applications.
                            </>
                          ) : (
                            <>
                              Your free trial expires in
                              <strong> {remainingDays} days</strong>
                              <br />
                              <br />
                              Upgrade anytime to continue posting jobs and accessing premium features.
                            </>
                          )}
                        </Typography>
                      </Paper>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
           </>
        ) : currentPlan === "PAY_AS_YOU_GO" ? (
          <>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper
                  elevation={0}
                  sx={{
                    border: "1px solid #ececec",
                    borderRadius: 3,
                    p: 3,
                  }}
                >
                  <Grid container spacing={3}>
                    {/* LEFT */}

                    <Grid item xs={12} md={5}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          textTransform: "uppercase",
                          fontWeight: "bold",
                          color: "#666",
                          mb: 1,
                        }}
                      >
                        CURRENT PLAN STATUS
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 2,
                        }}
                      >
                        <Typography
                          variant="h4"
                          sx={{
                            fontWeight: "bold",
                            color: "#1565c0",
                          }}
                        >
                          Pay-As-You-Go
                        </Typography>

                        <Chip
                          label={
                            isPlanExpired
                              ? "EXPIRED"
                              : "ACTIVE"
                          }
                          sx={{
                            background: isPlanExpired
                              ? "#eeeeee"
                              : "#e3f2fd",

                            color: isPlanExpired
                              ? "#666"
                              : "#1565c0",

                            fontWeight: "bold",
                          }}
                        />
                      </Box>

                      <Typography sx={{ mb: 1 }}>
                        Purchased On:
                        <strong>
                          {" "}
                          {latestCredit?.created_at
                            ? new Date(
                                latestCredit.created_at
                              ).toLocaleDateString("en-US", {
                                month: "long",
                                day: "numeric",
                                year: "numeric",
                              })
                            : "-"}
                        </strong>
                      </Typography>

                      <Typography sx={{ mb: 1 }}>
                        Credits Balance:
                        <strong>
                          {" "}
                          {jobsLimit} Credits
                        </strong>
                      </Typography>

                      <Typography sx={{ mb: 3 }}>
                        Valid Till:
                        <strong>
                          {" "}
                          {latestCredit?.expires_at
                            ? new Date(
                                latestCredit.expires_at
                              ).toLocaleDateString("en-US", {
                                month: "long",
                                day: "numeric",
                                year: "numeric",
                              })
                            : "-"}
                        </strong>
                      </Typography>

                      <Button
                        variant="contained"
                        sx={{
                          background: "#1565c0",
                        }}
                        onClick={() =>
                          (window.location.href =
                            "/pricing")
                        }
                      >
                        Explore Plans
                      </Button>
                    </Grid>

                    {/* USAGE */}

                    <Grid item xs={12} md={4}>
                      <Paper
                        elevation={0}
                        sx={{
                          p: 3,
                          background: "#f5f9ff",
                          borderRadius: 3,
                          height: "100%",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            color: "#1565c0",
                            mb: 3,
                          }}
                        >
                          Usage Overview
                        </Typography>

                        <Typography variant="body2">
                          Remaining Jobs
                        </Typography>

                        <Divider sx={{ my: 1 }} />

                        <Typography
                          sx={{
                            color: "#1565c0",
                            fontWeight: "bold",
                            mb: 3,
                          }}
                        >
                          {remainingJobs} / {totalPurchasedJobs}
                        </Typography>

                        <Typography variant="body2">
                          Remaining Applications
                        </Typography>

                        <Divider sx={{ my: 1 }} />

                        <Typography
                          sx={{
                            color: "#1565c0",
                            fontWeight: "bold",
                          }}
                        >
                          {remainingApplications} / {totalApplicationsLimit}
                        </Typography>
                      </Paper>
                    </Grid>

                    {/* RIGHT */}

                    <Grid item xs={12} md={3}>
                      <Paper
                        elevation={0}
                        sx={{
                          p: 3,
                          background: "#f5f9ff",
                          borderRadius: 3,
                          height: "100%",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            color: "#1565c0",
                            mb: 2,
                          }}
                        >
                          Pay-As-You-Go
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{
                            lineHeight: 2,
                            color: "#555",
                          }}
                        >
                          You are using job credits.
                          <br />
                          <br />
                          Each purchased job allows
                          processing candidate applications.
                        </Typography>
                      </Paper>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
                      </>
                     ) : currentPlan === "PROFESSIONAL" ? (
                     <>
                       <Grid container spacing={3}>
                         <Grid item xs={12}>
                           <Paper
                             elevation={0}
                             sx={{
                               border: "1px solid #ececec",
                               borderRadius: 3,
                               p: 3,
                             }}
                           >
                             <Grid container spacing={3}>

                               {/* LEFT */}

                               <Grid item xs={12} md={5}>
                                 <Typography
                                   variant="subtitle2"
                                   sx={{
                                     textTransform: "uppercase",
                                     fontWeight: "bold",
                                     color: "#666",
                                     mb: 1,
                                   }}
                                 >
                                   CURRENT PLAN STATUS
                                 </Typography>

                                 <Box
                                   sx={{
                                     display: "flex",
                                     alignItems: "center",
                                     gap: 1,
                                     mb: 2,
                                   }}
                                 >
                                   <Typography
                                     variant="h4"
                                     sx={{
                                       fontWeight: "bold",
                                       color: "#4F46E5",
                                     }}
                                   >
                                     Professional Plan
                                   </Typography>

                                   <Box
                                     sx={{
                                       display: 'flex',
                                       flexDirection: 'column',
                                       alignItems: 'center',
                                       justifyContent: 'center',
                                       py: '8px',
                                       px: '16px',
                                       borderRadius: '8px',
                                       background: 'linear-gradient(90deg, #4F46E5, #60A5FA)',
                                       color: 'white',
                                       boxShadow: '0 4px 10px rgba(79, 70, 229, 0.2)',
                                       width: 'fit-content',
                                       ml: 1
                                     }}
                                   >
                                     <Typography
                                       sx={{
                                         fontWeight: 500,
                                         fontSize: '0.75rem',
                                         lineHeight: 1.4,
                                         textAlign: 'center'
                                       }}
                                     >
                                       Launch Offer
                                     </Typography>
                                     <Typography
                                       sx={{
                                         fontWeight: 500,
                                         fontSize: '0.75rem',
                                         lineHeight: 1.4,
                                         textAlign: 'center'
                                       }}
                                     >
                                       Exclusive Pricing for First 100 Customers
                                     </Typography>
                                   </Box>

                                   <Chip
                                     label={
                                       isPlanExpired
                                         ? "EXPIRED"
                                         : "ACTIVE"
                                     }
                                     sx={{
                                       background: isPlanExpired
                                         ? "#eeeeee"
                                         : "#EEF2FF",

                                       color: isPlanExpired
                                         ? "#666"
                                         : "#4F46E5",

                                       fontWeight: "bold",
                                     }}
                                   />
                                 </Box>

                                 <Typography
                                   variant="body2"
                                   sx={{
                                     mb: 3,
                                     color: "#555",
                                   }}
                                 >
                                   For growing companies with regular hiring.
                                 </Typography>

                                 <Typography sx={{ mb: 1 }}>
                                   Valid Till:
                                   <strong>
                                     {" "}
                                     {expiryDate
                                       ? new Date(expiryDate).toLocaleDateString("en-US", {
                                           month: "long",
                                           day: "numeric",
                                           year: "numeric",
                                         })
                                       : "-"}
                                   </strong>
                                 </Typography>

                                 <Typography sx={{ mb: 1 }}>
                                   Plan Duration:
                                   <strong> 1 Year</strong>
                                 </Typography>

                                 <Typography sx={{ mb: 3 }}>
                                   Includes:
                                   <strong>
                                     {" "}
                                     50 Jobs + 300 Applications
                                   </strong>
                                 </Typography>

                                 <Button
                                   variant="contained"
                                   sx={{
                                     background: "#4F46E5",
                                   }}
                                   onClick={() =>
                                     (window.location.href =
                                       "/pricing")
                                   }
                                 >
                                   Upgrade Plan
                                 </Button>
                               </Grid>

                               {/* LIMITS */}

                               <Grid item xs={12} md={4}>
                                 <Paper
                                   elevation={0}
                                   sx={{
                                     p: 3,
                                     background: "#F8FAFC",
                                     borderRadius: 3,
                                     height: "100%",
                                   }}
                                 >
                                   <Typography
                                     sx={{
                                       fontWeight: "bold",
                                       color: "#4F46E5",
                                       mb: 3,
                                     }}
                                   >
                                     Professional Plan Limits
                                   </Typography>

                                   <Typography variant="body2">
                                     Active Job Postings
                                   </Typography>

                                   <Divider sx={{ my: 1 }} />

                                   <Typography
                                     sx={{
                                       color: "#4F46E5",
                                       fontWeight: "bold",
                                       mb: remainingJobs <= 0 ? 1 : 3,
                                     }}
                                   >
                                     {remainingJobs} / 50
                                   </Typography>

                                   {remainingJobs <= 0 && (
                                     <Button
                                       variant="outlined"
                                       size="small"
                                       sx={{
                                         mb: 3,
                                         borderColor: "#4F46E5",
                                         color: "#4F46E5",
                                         textTransform: "none",
                                         fontWeight: "bold",
                                         "&:hover": {
                                           backgroundColor: "#F8FAFC",
                                           borderColor: "#4338CA",
                                         },
                                       }}
                                       onClick={() => window.location.href = "/pricing?type=overage&plan=professional"}
                                     >
                                       Upgrade To Professional Overage Add-ons
                                     </Button>
                                   )}

                                   <Typography variant="body2">
                                     Candidate Applications
                                   </Typography>

                                   <Divider sx={{ my: 1 }} />

                                   <Typography
                                     sx={{
                                       color: "#4F46E5",
                                       fontWeight: "bold",
                                     }}
                                   >
                                     {remainingApplications} / 300
                                   </Typography>

                                   <Typography
                                     variant="caption"
                                     sx={{
                                       display: "block",
                                       mt: 1,
                                       color: "#777",
                                       lineHeight: 1.6,
                                     }}
                                   >
                                     Professional plan limits reset after plan expiry.
                                     Unused jobs and application processing
                                     will not carry forward to future plans.
                                   </Typography>
                                 </Paper>
                               </Grid>

                               {/* RIGHT */}

                               <Grid item xs={12} md={3}>
                                 <Paper
                                   elevation={0}
                                   sx={{
                                     p: 3,
                                     background: "#F8FAFC",
                                     borderRadius: 3,
                                     height: "100%",
                                   }}
                                 >
                                   <Typography
                                     sx={{
                                       fontWeight: "bold",
                                       color: "#4F46E5",
                                       mb: 2,
                                     }}
                                   >
                                     Professional Plan
                                   </Typography>

                                   <Typography
                                     variant="body2"
                                     sx={{
                                       lineHeight: 2,
                                       color: "#555",
                                     }}
                                   >
                                     Your Professional subscription gives access
                                     to 50 active jobs and 300 candidate
                                     application processing credits for 1 year.
                                   </Typography>
                                 </Paper>
                               </Grid>

                             </Grid>
                           </Paper>
                         </Grid>

                        {/* OVERAGE USAGE SECTION */}
                        {overageUsage && 
                         (overageUsage.purchasedJobsTotal > 0 || 
                          (user?.professional_overage_jobs_total > 0 || user?.professional_overage_jobs > 0)) && (
                          <Grid item xs={12}>
                            <Paper
                              elevation={0}
                              sx={{
                                p: 4,
                                borderRadius: 4,
                                border: "1px solid #e0e0e0",
                                background: "#fff",
                                mt: 3,
                                boxShadow: "0 4px 20px rgba(0,0,0,0.05)"
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                                <Typography
                                  variant="h6"
                                  sx={{ fontWeight: "bold", color: "#333", mr: 2 }}
                                >
                                  OVERAGE USAGE
                                </Typography>
                                <Chip 
                                  label="Active Add-on" 
                                  size="small" 
                                  sx={{ 
                                    bgcolor: '#e6f7f7', 
                                    color: '#4F46E5', 
                                    fontWeight: 'bold',
                                    borderRadius: '6px'
                                  }} 
                                />
                              </Box>

                              <Grid container spacing={4}>
                                {/* LEFT SECTION */}
                                <Grid item xs={12} md={4}>
                                  <Paper
                                    elevation={0}
                                    sx={{
                                      p: 3,
                                      background: "#F8FAFC",
                                      borderRadius: 3,
                                      height: "100%",
                                    }}
                                  >
                                    <Box sx={{ mb: 2 }}>
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <Typography variant="body2" color="textSecondary">Extra Jobs Purchased</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{overageUsage.purchasedJobs}</Typography>
                                      </Box>
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <Typography variant="body2" color="textSecondary">Remaining Jobs</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#4F46E5' }}>{overageUsage.remainingJobs}</Typography>
                                      </Box>
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <Typography variant="body2" color="textSecondary">Remaining Applications</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#4F46E5' }}>{overageUsage.remainingApps}</Typography>
                                      </Box>
                                      <Divider sx={{ my: 1.5, borderColor: 'rgba(0,139,139,0.1)' }} />
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <Typography variant="body2" color="textSecondary">Overage Valid Till</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                          {overageUsage.overageExpiry ? new Date(overageUsage.overageExpiry).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : (currentPlan === "PROFESSIONAL" ? '6 Months' : '30 Days')}
                                        </Typography>
                                      </Box>
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography variant="body2" color="textSecondary">Price per extra job</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>₹{overageUsage.pricePerJob || (currentPlan === "PROFESSIONAL" ? 29 : 39)}</Typography>
                                      </Box>
                                      <Button
                                        variant="contained"
                                        size="small"
                                        fullWidth
                                        sx={{ 
                                          mt: 3, 
                                          bgcolor: '#4F46E5',
                                          '&:hover': { bgcolor: '#4338CA' },
                                          textTransform: 'none',
                                          fontWeight: 'bold'
                                        }}
                                        onClick={() => window.location.href = `/pricing?type=overage&plan=${currentPlan.toLowerCase()}`}
                                      >
                                        Add More Overage
                                      </Button>
                                    </Box>
                                  </Paper>
                                </Grid>

                                {/* CENTER SECTION */}
                                <Grid item xs={12} md={5}>
                                  <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <Box sx={{ mb: 4 }}>
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333' }}>
                                          1. Remaining Jobs
                                        </Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#4F46E5' }}>
                                          {overageUsage.remainingJobs} / {overageUsage.purchasedJobs}
                                        </Typography>
                                      </Box>
                                      <LinearProgress 
                                        variant="determinate" 
                                        value={overageUsage.purchasedJobs > 0 ? (overageUsage.remainingJobs / overageUsage.purchasedJobs) * 100 : 0} 
                                        sx={{ 
                                          height: 8, 
                                          borderRadius: 4,
                                          bgcolor: '#f0f0f0',
                                          '& .MuiLinearProgress-bar': {
                                            bgcolor: '#4F46E5',
                                            borderRadius: 4
                                          }
                                        }}
                                      />
                                    </Box>

                                    <Box>
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333' }}>
                                          2. Remaining Applications
                                        </Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#4F46E5' }}>
                                          {overageUsage.remainingApps} / {overageUsage.appLimit}
                                        </Typography>
                                      </Box>
                                      <LinearProgress 
                                        variant="determinate" 
                                        value={overageUsage.appLimit > 0 ? (overageUsage.remainingApps / overageUsage.appLimit) * 100 : 0} 
                                        sx={{ 
                                          height: 8, 
                                          borderRadius: 4,
                                          bgcolor: '#f0f0f0',
                                          '& .MuiLinearProgress-bar': {
                                            bgcolor: '#4F46E5',
                                            borderRadius: 4
                                          }
                                        }}
                                      />
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          display: "block",
                                          mt: 1,
                                          color: "#777",
                                          lineHeight: 1.6,
                                        }}
                                      >
                                        Overage limits reset after plan expiry. Unused
                                        extra jobs and application processing credits
                                        will not carry forward to future billing cycles.
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Grid>

                                {/* RIGHT SECTION */}
                                <Grid item xs={12} md={3}>
                                  <Paper
                                    elevation={0}
                                    sx={{
                                      p: 3,
                                      background: "#F8FAFC",
                                      borderRadius: 3,
                                      height: "100%",
                                      display: 'flex',
                                      flexDirection: 'column'
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontWeight: "bold",
                                        color: "#4F46E5",
                                        mb: 2,
                                      }}
                                    >
                                      How Overage Works
                                    </Typography>
                                    <Box sx={{ flexGrow: 1 }}>
                                      <ul style={{ paddingLeft: '1.2rem', margin: 0 }}>
                                        <li style={{ marginBottom: '8px' }}>
                                          <Typography variant="caption" sx={{ color: '#555', fontSize: '0.75rem', display: 'list-item' }}>
                                            Extra jobs are valid for the next {currentPlan === "PROFESSIONAL" ? "6 months" : "billing month only"}
                                          </Typography>
                                        </li>
                                        <li style={{ marginBottom: '8px' }}>
                                          <Typography variant="caption" sx={{ color: '#555', fontSize: '0.75rem', display: 'list-item' }}>
                                            All purchased overage jobs are valid only for the next {currentPlan === "PROFESSIONAL" ? "6 months" : "billing month of starter plan"}.
                                          </Typography>
                                        </li>
                                        <li style={{ marginBottom: '8px' }}>
                                          <Typography variant="caption" sx={{ color: '#555', fontSize: '0.75rem', display: 'list-item' }}>
                                            Each extra job includes 5 candidate applications
                                          </Typography>
                                        </li>
                                        <li style={{ marginBottom: '8px' }}>
                                          <Typography variant="caption" sx={{ color: '#555', fontSize: '0.75rem', display: 'list-item' }}>
                                            Overage is used only after {currentPlan === "PROFESSIONAL" ? "Professional" : "Starter"} Plan jobs usage limit is exhausted
                                          </Typography>
                                        </li>
                                        <li>
                                          <Typography variant="caption" sx={{ color: '#555', fontSize: '0.75rem', display: 'list-item' }}>
                                            Up to {currentPlan === "PROFESSIONAL" ? "100" : "20"} extra jobs can be allowed .
                                          </Typography>
                                        </li>
                                      </ul>
                                    </Box>
                                  </Paper>
                                </Grid>
                              </Grid>
                            </Paper>
                          </Grid>
                        )}
                       </Grid>
                      </>
                     ) : currentPlan === "STARTER" ? (
                     <>
                       <Grid container spacing={3}>
                         <Grid item xs={12}>
                           <Paper
                             elevation={0}
                             sx={{
                               border: "1px solid #ececec",
                               borderRadius: 3,
                               p: 3,
                             }}
                           >
                             <Grid container spacing={3}>

                               {/* LEFT */}

                               <Grid item xs={12} md={5}>
                                 <Typography
                                   variant="subtitle2"
                                   sx={{
                                     textTransform: "uppercase",
                                     fontWeight: "bold",
                                     color: "#666",
                                     mb: 1,
                                   }}
                                 >
                                   CURRENT PLAN STATUS
                                 </Typography>

                                 <Box
                                   sx={{
                                     display: "flex",
                                     alignItems: "center",
                                     gap: 1,
                                     mb: 2,
                                   }}
                                 >
                                   <Typography
                                     variant="h4"
                                     sx={{
                                       fontWeight: "bold",
                                       color: "#4F46E5",
                                     }}
                                   >
                                     Starter Plan
                                   </Typography>

                                   <Chip
                                     label={
                                       isPlanExpired
                                         ? "EXPIRED"
                                         : "ACTIVE"
                                     }
                                     sx={{
                                       background: isPlanExpired
                                         ? "#eeeeee"
                                         : "#EEF2FF",

                                       color: isPlanExpired
                                         ? "#666"
                                         : "#4F46E5",

                                       fontWeight: "bold",
                                     }}
                                   />
                                 </Box>

                                 <Typography
                                   variant="body2"
                                   sx={{
                                     mb: 3,
                                     color: "#555",
                                   }}
                                 >
                                   Perfect for startups and growing teams.
                                 </Typography>

                                 <Typography sx={{ mb: 1 }}>
                                   Valid Till:
                                   <strong>
                                     {" "}
                                     {expiryDate
                                       ? new Date(expiryDate).toLocaleDateString("en-US", {
                                           month: "long",
                                           day: "numeric",
                                           year: "numeric",
                                         })
                                       : "-"}
                                   </strong>
                                 </Typography>

                                 <Typography sx={{ mb: 1 }}>
                                   Plan Duration:
                                   <strong> 30 Days</strong>
                                 </Typography>

                                 <Typography sx={{ mb: 3 }}>
                                   Includes:
                                   <strong>
                                     {" "}
                                     10 Jobs + 50 Applications
                                   </strong>
                                 </Typography>

                                 <Button
                                   variant="contained"
                                   sx={{
                                     background: "#4F46E5",
                                   }}
                                   onClick={() =>
                                     (window.location.href =
                                       "/pricing")
                                   }
                                 >
                                   Upgrade Plan
                                 </Button>
                               </Grid>

                               {/* LIMITS */}

                               <Grid item xs={12} md={4}>
                                 <Paper
                                   elevation={0}
                                   sx={{
                                     p: 3,
                                     background: "#F8FAFC",
                                     borderRadius: 3,
                                     height: "100%",
                                   }}
                                 >
                                   <Typography
                                     sx={{
                                       fontWeight: "bold",
                                       color: "#4F46E5",
                                       mb: 3,
                                     }}
                                   >
                                     Starter Plan Limits
                                   </Typography>

                                   <Typography variant="body2">
                                     Active Job Postings
                                   </Typography>

                                   <Divider sx={{ my: 1 }} />

                                   <Typography
                                     sx={{
                                       color: "#4F46E5",
                                       fontWeight: "bold",
                                       mb: remainingJobs <= 0 ? 1 : 3,
                                     }}
                                   >
                                     {remainingJobs} / 10
                                   </Typography>

                                   {remainingJobs <= 0 && (
                                     <Button
                                       variant="outlined"
                                       size="small"
                                       sx={{
                                         mb: 3,
                                         borderColor: "#4F46E5",
                                         color: "#4F46E5",
                                         textTransform: "none",
                                         fontWeight: "bold",
                                         "&:hover": {
                                           backgroundColor: "#F8FAFC",
                                           borderColor: "#4338CA",
                                         },
                                       }}
                                       onClick={() => window.location.href = "/pricing?type=overage&plan=starter"}
                                     >
                                       Upgrade To Overage Add-ons
                                     </Button>
                                   )}

                                   <Typography variant="body2">
                                     Candidate Applications
                                   </Typography>

                                   <Divider sx={{ my: 1 }} />

                                   <Typography
                                     sx={{
                                       color: "#4F46E5",
                                       fontWeight: "bold",
                                     }}
                                   >
                                     {remainingApplications} / 50
                                   </Typography>

                                   <Typography
                                     variant="caption"
                                     sx={{
                                       display: "block",
                                       mt: 1,
                                       color: "#777",
                                       lineHeight: 1.6,
                                     }}
                                   >
                                     Starter plan limits reset after plan expiry.
                                     Unused jobs and application processing
                                     will not carry forward to future plans.
                                   </Typography>
                                 </Paper>
                               </Grid>

                               {/* RIGHT */}

                               <Grid item xs={12} md={3}>
                                 <Paper
                                   elevation={0}
                                   sx={{
                                     p: 3,
                                     background: "#F8FAFC",
                                     borderRadius: 3,
                                     height: "100%",
                                   }}
                                 >
                                   <Typography
                                     sx={{
                                       fontWeight: "bold",
                                       color: "#4F46E5",
                                       mb: 2,
                                     }}
                                   >
                                     Starter Plan
                                   </Typography>

                                   <Typography
                                     variant="body2"
                                     sx={{
                                       lineHeight: 2,
                                       color: "#555",
                                     }}
                                   >
                                     Your Starter subscription gives access
                                     to 10 active jobs and 50 candidate
                                     application processing credits for 30 days.
                                   </Typography>
                                 </Paper>
                               </Grid>

                             </Grid>
                           </Paper>
                         </Grid>

                        {/* OVERAGE USAGE SECTION */}
                        {overageUsage &&
                         (
                           overageUsage.purchasedJobs > 0 ||
                           overageUsage.remainingJobs > 0 ||
                           overageUsage.appLimit > 0 ||
                           overageUsage.remainingApps > 0
                         ) && (
                          <Grid item xs={12}>
                            <Paper
                              elevation={0}
                              sx={{
                                p: 4,
                                borderRadius: 4,
                                border: "1px solid #e0e0e0",
                                background: "#fff",
                                mt: 3,
                                boxShadow: "0 4px 20px rgba(0,0,0,0.05)"
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                                <Typography
                                  variant="h6"
                                  sx={{ fontWeight: "bold", color: "#333", mr: 2 }}
                                >
                                  OVERAGE USAGE
                                </Typography>
                                <Chip 
                                  label="Active Add-on" 
                                  size="small" 
                                  sx={{ 
                                    bgcolor: '#e6f7f7', 
                                    color: '#4F46E5', 
                                    fontWeight: 'bold',
                                    borderRadius: '6px'
                                  }} 
                                />
                              </Box>

                              <Grid container spacing={4}>
                                {/* LEFT SECTION */}
                                <Grid item xs={12} md={4}>
                                  <Paper
                                    elevation={0}
                                    sx={{
                                      p: 3,
                                      background: "#F8FAFC",
                                      borderRadius: 3,
                                      height: "100%",
                                    }}
                                  >
                                    <Box sx={{ mb: 2 }}>
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <Typography variant="body2" color="textSecondary">Extra Jobs Purchased</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{overageUsage.purchasedJobs}</Typography>
                                      </Box>
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <Typography variant="body2" color="textSecondary">Remaining Jobs</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#4F46E5' }}>{overageUsage.remainingJobs}</Typography>
                                      </Box>
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <Typography variant="body2" color="textSecondary">Remaining Applications</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#4F46E5' }}>{overageUsage.remainingApps}</Typography>
                                      </Box>
                                      <Divider sx={{ my: 1.5, borderColor: 'rgba(0,139,139,0.1)' }} />
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <Typography variant="body2" color="textSecondary">Overage Valid Till</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                          {overageUsage.overageExpiry ? new Date(overageUsage.overageExpiry).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : (currentPlan === "PROFESSIONAL" ? '6 Months' : '30 Days')}
                                        </Typography>
                                      </Box>
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography variant="body2" color="textSecondary">Price per extra job</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>₹{overageUsage.pricePerJob || (currentPlan === "PROFESSIONAL" ? 29 : 39)}</Typography>
                                      </Box>
                                      <Button
                                        variant="contained"
                                        size="small"
                                        fullWidth
                                        sx={{ 
                                          mt: 3, 
                                          bgcolor: '#4F46E5',
                                          '&:hover': { bgcolor: '#4338CA' },
                                          textTransform: 'none',
                                          fontWeight: 'bold'
                                        }}
                                        onClick={() => window.location.href = `/pricing?type=overage&plan=${currentPlan.toLowerCase()}`}
                                      >
                                        Add More Overage
                                      </Button>
                                    </Box>
                                  </Paper>
                                </Grid>

                                {/* CENTER SECTION */}
                                <Grid item xs={12} md={5}>
                                  <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <Box sx={{ mb: 4 }}>
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333' }}>
                                          1. Remaining Jobs
                                        </Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#4F46E5' }}>
                                          {overageUsage.remainingJobs} / {overageUsage.purchasedJobs}
                                        </Typography>
                                      </Box>
                                      <LinearProgress 
                                        variant="determinate" 
                                        value={overageUsage.purchasedJobs > 0 ? (overageUsage.remainingJobs / overageUsage.purchasedJobs) * 100 : 0} 
                                        sx={{ 
                                          height: 8, 
                                          borderRadius: 4,
                                          bgcolor: '#f0f0f0',
                                          '& .MuiLinearProgress-bar': {
                                            bgcolor: '#4F46E5',
                                            borderRadius: 4
                                          }
                                        }}
                                      />
                                    </Box>

                                    <Box>
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333' }}>
                                          2. Remaining Applications
                                        </Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#4F46E5' }}>
                                          {overageUsage.remainingApps} / {overageUsage.appLimit}
                                        </Typography>
                                      </Box>
                                      <LinearProgress 
                                        variant="determinate" 
                                        value={overageUsage.appLimit > 0 ? (overageUsage.remainingApps / overageUsage.appLimit) * 100 : 0} 
                                        sx={{ 
                                          height: 8, 
                                          borderRadius: 4,
                                          bgcolor: '#f0f0f0',
                                          '& .MuiLinearProgress-bar': {
                                            bgcolor: '#4F46E5',
                                            borderRadius: 4
                                          }
                                        }}
                                      />
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          display: "block",
                                          mt: 1,
                                          color: "#777",
                                          lineHeight: 1.6,
                                        }}
                                      >
                                        Overage limits reset after plan expiry. Unused
                                        extra jobs and application processing credits
                                        will not carry forward to future billing cycles.
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Grid>

                                {/* RIGHT SECTION */}
                                <Grid item xs={12} md={3}>
                                  <Paper
                                    elevation={0}
                                    sx={{
                                      p: 3,
                                      background: "#F8FAFC",
                                      borderRadius: 3,
                                      height: "100%",
                                      display: 'flex',
                                      flexDirection: 'column'
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontWeight: "bold",
                                        color: "#4F46E5",
                                        mb: 2,
                                      }}
                                    >
                                      How Overage Works
                                    </Typography>
                                    <Box sx={{ flexGrow: 1 }}>
                                      <ul style={{ paddingLeft: '1.2rem', margin: 0 }}>
                                        <li style={{ marginBottom: '8px' }}>
                                          <Typography variant="caption" sx={{ color: '#555', fontSize: '0.75rem', display: 'list-item' }}>
                                            Extra jobs are valid for the next {currentPlan === "PROFESSIONAL" ? "6 months" : "billing month only"}
                                          </Typography>
                                        </li>
                                        <li style={{ marginBottom: '8px' }}>
                                          <Typography variant="caption" sx={{ color: '#555', fontSize: '0.75rem', display: 'list-item' }}>
                                            All purchased overage jobs are valid only for the next {currentPlan === "PROFESSIONAL" ? "6 months" : "billing month of starter plan"}.
                                          </Typography>
                                        </li>
                                        <li style={{ marginBottom: '8px' }}>
                                          <Typography variant="caption" sx={{ color: '#555', fontSize: '0.75rem', display: 'list-item' }}>
                                            Each extra job includes 5 candidate applications
                                          </Typography>
                                        </li>
                                        <li style={{ marginBottom: '8px' }}>
                                          <Typography variant="caption" sx={{ color: '#555', fontSize: '0.75rem', display: 'list-item' }}>
                                            Overage is used only after {currentPlan === "PROFESSIONAL" ? "Professional" : "Starter"} Plan jobs usage limit is exhausted
                                          </Typography>
                                        </li>
                                        <li>
                                          <Typography variant="caption" sx={{ color: '#555', fontSize: '0.75rem', display: 'list-item' }}>
                                            Up to {currentPlan === "PROFESSIONAL" ? "100" : "20"} extra jobs can be allowed .
                                          </Typography>
                                        </li>
                                      </ul>
                                    </Box>
                                  </Paper>
                                </Grid>
                              </Grid>
                            </Paper>
                          </Grid>
                        )}
                       </Grid>
                      </>
                     ) : (
          <Box
            sx={{
              textAlign: "center",
              py: 8,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: 3,
                color: "#666",
              }}
            >
              No Active Subscription Found
            </Typography>

            <Button
              variant="contained"
              onClick={() =>
                (window.location.href = "/pricing")
              }
            >
              Explore Plans
            </Button>
          </Box>
        )}

      </Paper>
    </Container>
  );
}

export default Subscription;
